// i18n.js
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTrans from '@/locales/en'
import arTrans from '@/locales/ar'

const resources = {
  en: { translation: enTrans },
  ar: { translation: arTrans },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: ['en', 'ar'],
  interpolation: {
    escapeValue: false,
  },
})

export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang)
}

export default i18n
